import { useCallback, useEffect, useRef, useState } from "react";

export interface FormBindingRef {
  submitForm: () => void;
  resetForm: () => void;
}

export function useFormBinding() {
  const [isDirty, setIsDirty] = useState(false);
  const [isValid, setIsValid] = useState(true);

  const formRef = useRef<FormBindingRef | null>(null);

  const registerFormRef = useCallback((ref: FormBindingRef | null) => {
    formRef.current = ref;
  }, []);

  const handleSubmit = () => {
    formRef.current?.submitForm();
  };

  const handleReset = () => {
    formRef.current?.resetForm();
  };

  useEffect(() => {
    if (formRef.current) {
      registerFormRef(formRef.current);
    }
  }, [registerFormRef]);

  return {
    isDirty,
    isValid,
    setIsDirty,
    setIsValid,
    registerFormRef,
    handleSubmit,
    handleReset,
    formRef,
  };
}
